/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Client, RequestContext } from "../client";
import { BasicRepository } from "../repositories/basicRepository";
import type { MetadataTypeCollection } from "../resources/dynamicFormResources";
import type { SettingsId } from "./SettingsId";
import type { SettingsMetadataItemResource } from "./settingsMetadataResource";
export class SettingsRepository extends BasicRepository<SettingsMetadataItemResource, SettingsMetadataItemResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("Configuration", client, requestContext);
    }
    getById(id: SettingsId): Promise<SettingsMetadataItemResource> {
        return this.client.get<SettingsMetadataItemResource>(this.requestContext, this.client.getLink("Configuration"), { id });
    }
    getValues(resource: SettingsMetadataItemResource): Promise<any> {
        return this.client.get<any>(this.requestContext, resource.Links["Values"]);
    }
    getMetadata(resource: SettingsMetadataItemResource): Promise<MetadataTypeCollection> {
        return this.client.get<MetadataTypeCollection>(this.requestContext, resource.Links["Metadata"]);
    }
    saveValues(metadataResource: SettingsMetadataItemResource, resource: any) {
        return this.client.put(this.requestContext, metadataResource.Links["Values"], resource);
    }
}
